export default "__VITE_ASSET__BoPWQfqW__"